import { render, staticRenderFns } from "./EpotQuestionS.vue?vue&type=template&id=76310083&"
import script from "./EpotQuestionS.vue?vue&type=script&lang=js&"
export * from "./EpotQuestionS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports